module.exports = __webpack_public_path__ + "static/media/Ford-Ranger-III-Double-Cab-facelift-2019.843085c5.webp";